import * as React from 'react';
import { IconProps } from '../types';

const IcGel2 = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M18.703.39a1.186 1.186 0 0 0-.88-.39h-6.709a.426.426 0 1 0 0 .852h6.71c.095 0 .183.039.247.11.063.07.093.162.084.256l-1.646 16.016a.276.276 0 0 1-.276.248H8.766a.276.276 0 0 1-.275-.248L6.845 1.218A.328.328 0 0 1 6.93.962a.329.329 0 0 1 .247-.11h1.888a.426.426 0 1 0 0-.852H7.176a1.186 1.186 0 0 0-1.178 1.305l1.645 16.016c.053.508.434.907.92.995v4.163c0 .839.683 1.521 1.521 1.521h4.832c.838 0 1.52-.682 1.52-1.52v-2.731a.426.426 0 1 0-.851 0v2.73a.67.67 0 0 1-.67.67h-4.83a.67.67 0 0 1-.67-.67v-4.145h6.818c.581 0 1.064-.436 1.123-1.013l1.646-16.016a1.185 1.185 0 0 0-.299-.914Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M14.279 21.256H10.72a.426.426 0 1 0 0 .852h3.558a.426.426 0 1 0 0-.852ZM14.709 4.667h-4.44a.864.864 0 0 0-.864.863v6.252c0 .476.387.863.863.863h4.44a.864.864 0 0 0 .864-.863V5.53a.864.864 0 0 0-.863-.864Zm.011 7.115a.011.011 0 0 1-.011.011h-4.44a.012.012 0 0 1-.012-.011V5.53c0-.006.005-.012.011-.012h4.44c.007 0 .012.006.012.012v6.252Z"
    />
  </svg>
);

export default IcGel2;
